/**
 * transitions.dev modal job: scale and fade at the house motion band.
 * No 3D glare. The listing photo lightbox imports this so the open/close
 * is the catalog interaction, not a custom fade invented on the page.
 */
export const TRANSITIONS_MODAL_SURFACE =
  'data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95'
